/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import Script from "next/script";

interface Props {
	brand: string;
}

export const FooterScript = ({ brand }: Props): React.JSX.Element => {
	const epicComponentDomain = process.env.EPIC_COMPONENTS_DOMAIN;
	return (
		<Script
			async
			type="module"
			crossOrigin="anonymous"
			src={`${epicComponentDomain}/footer/${brand}-footer.mjs`}
		></Script>
	);
};
